import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { DashboardService } from "src/app/services/home/dashboard.service";
import { LoginService } from "src/app/services/login.service";
import { UserMaster } from "src/app/models/Masters/userMaster";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit, AfterViewInit, OnDestroy {
  user: UserMaster;
  totalViewCount: number;
  isUserHolostik: boolean;
  @ViewChild("footerEl", { static: false }) footerEl: ElementRef<HTMLElement>;
  private onScrollOrResize = () => this.updateVisibility();
  private settleTimer: any;
  private routeSettleTimer: any;
  private routerSub: Subscription;
  constructor(
    private loginService: LoginService,
    private dashboardService: DashboardService,
    private router: Router,
  ) {
    this.user = this.loginService.user();
    if (this.user.compId == 1) {
      this.isUserHolostik = true;
    } else {
      this.isUserHolostik = false;
    }
  }

  ngAfterViewInit() {
    const el = this.footerEl && this.footerEl.nativeElement;
    if (!el) return;
    window.addEventListener("scroll", this.onScrollOrResize, {
      passive: true,
    });
    window.addEventListener("resize", this.onScrollOrResize, {
      passive: true,
    });
    this.updateVisibility();

    this.settleTimer = setTimeout(() => this.updateVisibility(), 800);

    // The footer lives outside <router-outlet> (default-layout.component.html),
    // so it's only created once for the whole app session - route changes
    // swap the page content without ever re-firing ngAfterViewInit. Without
    // this, --footer-inset/is-visible would only ever reflect whatever page
    // was on screen at the last hard refresh until the user manually
    // scrolled or resized the window.
    this.routerSub = this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        if (this.routeSettleTimer) clearTimeout(this.routeSettleTimer);
        this.updateVisibility();
        this.routeSettleTimer = setTimeout(
          () => this.updateVisibility(),
          300,
        );
      });
  }

  ngOnDestroy() {
    window.removeEventListener("scroll", this.onScrollOrResize);
    window.removeEventListener("resize", this.onScrollOrResize);
    if (this.settleTimer) clearTimeout(this.settleTimer);
    if (this.routeSettleTimer) clearTimeout(this.routeSettleTimer);
    if (this.routerSub) this.routerSub.unsubscribe();
  }

  private updateVisibility() {
    const el = this.footerEl && this.footerEl.nativeElement;
    if (!el) return;
    const doc = document.documentElement;
    doc.style.setProperty("--footer-h", `${el.offsetHeight}px`);
    const atBottom =
      window.innerHeight + window.scrollY >= doc.scrollHeight - 6;
    el.classList.toggle("is-visible", atBottom);
    doc.style.setProperty(
      "--footer-inset",
      atBottom ? `${el.offsetHeight}px` : "0px",
    );
  }

  ngOnInit() {
    if (window.location.pathname == "/dashboard" && this.user.compId == 1) {
      this.getHitUpdateCount();
    } else {
      let tmp = sessionStorage.getItem("Count");
      if (tmp == null) {
        this.dashboardService
          .getHitViewCount(this.user.compId)
          .subscribe((res: any) => {
            const resData = res.details;
            if (res.responseCode == "200") {
              this.totalViewCount = resData.viewCount;
              sessionStorage.setItem("Count", resData.viewCount);
            } else {
              this.totalViewCount = 0;
            }
          });
      } else {
        this.totalViewCount = parseInt(tmp);
      }
    }
  }

  getHitUpdateCount() {
    this.dashboardService
      .getHitUpdateCount(this.user.compId)
      .subscribe((res: any) => {
        const resData = res.details;
        if (res.responseCode == "200") {
          this.totalViewCount = resData.viewCount;
          sessionStorage.setItem("Count", resData.viewCount);
        } else {
          this.totalViewCount = 0;
        }
      });
  }
}
